import React from "react";
import { ArrowRight, Phone, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VakmanschapInKalkzandsteen() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll();
  const {
    ref: subRef,
    isVisible: subVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const {
    ref: btnRef,
    isVisible: btnVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="4786" id="altijd-opgeladen-met-zapgo" className="dark bg-background text-foreground relative h-screen min-h-[800px] w-full overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586523/img/zapgo_hero_city.png')]" />
        {}
        <div className="absolute inset-0 bg-secondary/80 backdrop-blur-[2px]" />
        {}
        <div className="absolute inset-0 opacity-[0.12] pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586523/img/texture_noise_grain.png')] mix-blend-overlay" />
      </div>

      {}
      <div className="absolute left-6 md:left-10 top-1/2 -translate-y-1/2 hidden lg:flex items-center gap-4 -rotate-90 origin-center z-20 opacity-70">
        <span className="text-xs font-bold tracking-[0.3em] uppercase text-primary whitespace-nowrap">
          Amsterdam • Rotterdam • Utrecht
        </span>
        <div className="w-12 h-[1px] bg-primary/50" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center justify-center text-center h-full pt-20">
        
        {}
        <div ref={titleRef} className={`transition-all duration-1000 ease-out transform ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h1 className="flex flex-col items-center leading-none">
            {}
          <img src="https://finer-monkfish.10web.cloud/wp-content/uploads/2026/03/image_8xrj8zwr.jpg" alt="ZapGO!" className="w-auto object-contain brightness-100 !rounded-none !shadow-none !h-[97px]" style={{
            maxHeight: '200px',
            width: 'auto'
          }} />
            {}
            <span className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mt-2 md:-mt-6 tracking-tight drop-shadow-2xl">
              Altijd Opgeladen.
            </span>
          </h1>
        </div>

        {}
        <div ref={subRef} className={`mt-8 max-w-2xl transition-all duration-1000 delay-300 ease-out transform ${subVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <p className="text-xl md:text-2xl text-white font-semibold leading-relaxed">
            <span className="block mb-2">De slimste powerbank verhuur van Nederland.</span>
            <span className="text-muted-foreground text-lg font-normal">Nooit meer een lege batterij, waar je ook bent.</span>
          </p>
        </div>

        {}
        <div ref={btnRef} className={`mt-10 flex flex-col sm:flex-row gap-4 transition-all duration-1000 delay-500 ease-out transform ${btnVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground border-none px-10 py-7 text-lg font-bold tracking-wide shadow-[0_0_30px_rgba(34,197,94,0.3)] hover:shadow-[0_0_40px_rgba(34,197,94,0.5)] transition-all duration-300">
            <Link to="#">
              Vind een Charger
              <MapPin className="ml-2 h-5 w-5" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="bg-transparent border-white/20 text-white hover:bg-white/5 hover:text-white hover:border-white/40 px-10 py-7 text-lg font-medium backdrop-blur-md transition-all duration-300">
            <Link to="/PartnersPage">
              Word Partner
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-20 opacity-60">
        <span className="text-[10px] uppercase tracking-widest text-primary font-bold">Scroll</span>
        <div className="w-[1px] h-16 bg-gradient-to-b from-primary/0 via-primary/50 to-primary/0 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1/2 bg-primary animate-[drop_2s_infinite]" />
        </div>
      </div>

      {}
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-background/90 to-transparent z-10 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-background to-transparent z-10 pointer-events-none" />
      
      <style>{`
        @keyframes drop {
          0% { top: -50%; opacity: 0; }
          50% { opacity: 1; }
          100% { top: 100%; opacity: 0; }
        }
      `}</style>
    </section>;
}